import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
    RECOMMENDATION_STATUSES,
    RECOMMENDATION_STATUSES_ICONS,
    ON_TRACK,
    OFF_TRACK,
    ON_TRACK_TEXT_POINTER,
    OFF_TRACK_TEXT_POINTER,
} from '../../constants/assessments';
import { localize } from '../../common/localization';

const getNotificationTextPointer = (recommendationStatus, appName) => {
    switch (recommendationStatus) {
        case RECOMMENDATION_STATUSES[appName][ON_TRACK]:
            return ON_TRACK_TEXT_POINTER;
        case RECOMMENDATION_STATUSES[appName][OFF_TRACK]:
            return OFF_TRACK_TEXT_POINTER;
        default:
            return 'dashboard-';
    }
};

const PMRecommendationNotification = ({ recommendationStatus, appName }) => {
    const containerClassName = classNames('dashboard-stationary-notification', {
        'dashboard-on-track-notification':
            recommendationStatus === RECOMMENDATION_STATUSES[appName][ON_TRACK],
        'dashboard-off-track-notification':
            recommendationStatus === RECOMMENDATION_STATUSES[appName][OFF_TRACK],
    });

    const recommendationStatusClassName = classNames(
        'dashboard-icon-amplify',
        'dashboard-' + RECOMMENDATION_STATUSES_ICONS[recommendationStatus],
    );

    const notificationTextPointer = getNotificationTextPointer(recommendationStatus, appName);
    const translatedNotificationText = notificationTextPointer
        ? localize(notificationTextPointer)
        : 'dashboard-';

    return (
        <div className={containerClassName}>
            <i className={recommendationStatusClassName} />
            <span>{translatedNotificationText}</span>
        </div>
    );
};

PMRecommendationNotification.propTypes = {
    recommendationStatus: PropTypes.string.isRequired,
    appName: PropTypes.string.isRequired,
};

export default PMRecommendationNotification;
